<template>
<div class="fact-checker-average-table-wrapper" data-message="(From 2/16/2021 - 7/16/2021)">
	<div class="average_table_html">
		<h3 class="red-bar-section">Fact Check Review
			<div class="date_message"></div>
		</h3>
		<div id="polling-data-rcp">
			<table class="data large fc_top_label">
				<tbody>
					<tr class="header">
						<th><span>Fact Checker</span></th>
						<!-- <th><span>Relevant Checks</span></th> -->
						<!-- <th><span>Claim of Fact</span></th> -->
						<th><span>Author of Claim</span></th>
						<th><span>Claim Author Type</span></th>
                        <!-- <th><span>Claim Evidence For Verdict</span></th> -->
						<!-- <th><span>Evidence for Verdict</span></th> -->
						<!-- <th><span>Source for Verdict</span></th> -->
					</tr>
					<tr class="" v-for="(item, index) in data" :key="`${index}-table-row`"
                        :class="{alt : index % 2 == 1}">
						<td>
                            <router-link v-if="item.link" :to="item.link">{{item.name}}</router-link>
                            <span v-else >{{item.name}}</span>
                        </td>
						<!-- <td>37</td> -->
						<!-- <td>97%</td> -->
						<td>
                            <div v-for="(claim_source, index) in item.source_of_claim" 
                                :key="`${index}-${claim_source.org_id}`"
                                class="claim_source_averages"
                                v-html="`${claim_source.percent}% ${claim_source.name}`">
                                </div>
						</td>
						<!-- <td>
							<div>
								100% Candidate Site
							</div>
						</td>
						<td>
							<div>
								16% Joe Biden campaign
							</div>
							<div>
								5% Garland Favorito
							</div>
							<div>
								5% Max Flugrath
							</div>
							<div>
								5% Renzo Olivari
							</div>
							<div>
								5% Terry McAuliffe campaign
							</div>
						</td> -->
                        <td>
                            <div v-for="(cs_type, index) in item.source_of_claim_types" 
                                :key="`${index}-${cs_type.org_id}`" >
                                <span v-if="cs_type.source_type_count !== 0 && cs_type.name !== null" 
                                    v-html="`${cs_type.percent}% ${cs_type.name}`" ></span>
                            </div>
                        </td>
                        <!-- <td>
                            <div v-for="(evidence, index) in item.evidence_for_verdict" 
                                :key="`${index}-${evidence.org_id}`" >
                                <span v-if="evidence.percent !== null && evidence.name !== null" 
                                    v-html="`${evidence.percent}% ${evidence.name}`" ></span>
                            </div>
                        </td> -->
					</tr>
				</tbody>
			</table>
		</div>
	</div>
</div>
</template>

<script>
export default {
    name: 'fact-check-review-table',
    props: {
        data: {
            type: Array,
            required: true,
        },
    },
}
</script>

<style lang="scss">

</style>